import { onBeforeUnmount } from 'vue'
import { AxiosRequestConfig } from 'axios'

export default function useAbortRequest () {
    let abortController = new AbortController()

    // Methods
    function createAbortController () {
        abortController.abort()
        abortController = new AbortController()
    }
    function getRequestConfig () {
        return {
            signal: abortController.signal
        }
    }
    function makeRequestConfig (config: AxiosRequestConfig = {}) {
        createAbortController()

        return {
            ...config,
            ...getRequestConfig()
        }
    }

    // Hooks
    onBeforeUnmount(() => {
        abortController.abort()
    })

    return {
        makeRequestConfig,
    }
}
